import { ReactNode } from 'react';
import { Box, Typography } from '@mui/material';
import { useThemeContext } from '../../hook/useThemeManager';
import { theme } from '../../constants/theme';
import { FONT_ENUM } from '../../types/global/fonts.types';

type FormWrapperProps = {
    title: string;
    subtitle?: string;
    children: ReactNode;
};

export function LoginWrapper({ title, subtitle, children }: FormWrapperProps) {
    const { themeStyle } = useThemeContext();

    const defaultSubtitle =
        'Log in to join creative campaigns, share your work, and connect with the creative community. Your spotlight is waiting.';

    return (
        <Box>
            <Typography
                style={{
                    maxWidth: 400,
                    width: '100%',
                    textAlign: 'left',
                    fontSize: 24,
                    fontFamily: FONT_ENUM.MAIN_BOLD,
                    fontStyle: 'normal',
                    fontWeight: '500',
                    lineHeight: '32px',
                    color: theme[themeStyle].primary_white,
                }}>
                {title}
            </Typography>
            <Typography
                sx={{
                    maxWidth: 400,
                    width: '100%',
                    textAlign: 'left',
                    fontSize: '14px',
                    fontFamily: FONT_ENUM.MAIN_MEDIUM,
                    fontStyle: 'normal',
                    marginTop: 2,
                    color: theme[themeStyle].subtitleGrey,
                }}>
                {subtitle || defaultSubtitle}
            </Typography>
            {children}
        </Box>
    );
}
